import BulkActionButtons from 'components/common/BulkActionButtons'
import { CustomDatagridBody } from 'components/common/CustomDatagridBody'
import { DEFAULT_PER_PAGE } from 'globalVariables'
import { useTranslate } from 'ra-core'
import { Datagrid, List, ListProps, TextField } from 'react-admin'
import { formatDateString } from 'utils/formatDateString'
import DateFieldCustom from 'utils/overrides/DateFieldCustom'
import RetailerTagListFilters from './RetailerTagListFilters'

const RetailerTagList = (props: ListProps) => {
    const translate = useTranslate()

    return (
        <List
            {...props}
            sort={{ field: 'tag', order: 'DESC' }}
            perPage={DEFAULT_PER_PAGE}
            filters={RetailerTagListFilters}
            empty={false}
            sx={{
                '& .RaDatagrid-headerCell': {
                    fontWeight: 700
                },
                form: {
                    minHeight: 'unset',
                    alignItems: 'center',
                    '.MuiFormControl-root': {
                        marginTop: '0 !important'
                    },
                    '.filter-field': {
                        alignItems: 'center',
                        '.RaFilterFormInput-hideButton': {
                            marginBottom: 0
                        }
                    }
                },
                '& .RaBulkActionsToolbar-root': {
                    transform: 'unset !important'
                },
                '& .RaBulkActionsToolbar-toolbar': {
                    transform: 'unset !important'
                }
            }}
        >
            <Datagrid
                body={<CustomDatagridBody bulkActionButtons={<BulkActionButtons />} />}
                rowClick="edit"
            >
                <TextField source="tag" label={translate('manager.resources.tag.name')} />
                <DateFieldCustom
                    label={translate('manager.resources.general.last_updated')}
                    source="updated_at"
                    showTime
                    transform={(value) => formatDateString(value, true)}
                />
            </Datagrid>
        </List>
    )
}
export default RetailerTagList
